import { memo } from 'react';

import { clsx } from 'clsx';

import { ProductRatingType } from '@shared/types/product';
import { getInflectedWord } from '@shared/utils/getInflectedWord/getInflectedWord';

import cls from './ProductReviewsSummary.module.scss';

type ProductReviewsSummaryProps = {
  className?: string;
  rating?: ProductRatingType;
};

export const ProductReviewsSummary = memo<ProductReviewsSummaryProps>(({ className, rating }) => {
  const average = rating?.average;
  const reviewsCount = rating?.approvedReviewsCount ?? 0;

  if (!average && !reviewsCount) {
    return <div className={clsx(cls.wrap, cls.noReviews, className)}>Пока нет отзывов</div>;
  }

  return (
    <div className={clsx(cls.wrap, className)}>
      {average && (
        <div className={cls.rating}>
          <div className={cls.icon} />
          <span>{average.toFixed(1)}</span>
        </div>
      )}
      {reviewsCount && (
        <div className={cls.reviews}>
          {reviewsCount} {getInflectedWord(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}
        </div>
      )}
    </div>
  );
});
